import { render, staticRenderFns } from "./comission-counter.vue?vue&type=template&id=00b5f6ca&scoped=true"
import script from "./comission-counter.vue?vue&type=script&lang=js"
export * from "./comission-counter.vue?vue&type=script&lang=js"
import style0 from "./comission-counter.vue?vue&type=style&index=0&id=00b5f6ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5f6ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b5f6ca')) {
      api.createRecord('00b5f6ca', component.options)
    } else {
      api.reload('00b5f6ca', component.options)
    }
    module.hot.accept("./comission-counter.vue?vue&type=template&id=00b5f6ca&scoped=true", function () {
      api.rerender('00b5f6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/comission/components/comission-counter.vue"
export default component.exports